var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cliam_settlement_intro"}},[(_vm.productCategorySelectStyle == '1')?_c('normal-cliam-settlement-info',{attrs:{"productDetail":_vm.productDetail}}):_vm._e(),(_vm.productCategorySelectStyle == '2')?_c('business-cliam-settlement-info',{attrs:{"productDetail":_vm.productDetail}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }